import React from 'react';

const IconPrivacyTip = (props) => {
    return (
        <svg 
            className={props.className}
            xmlns="http://www.w3.org/2000/svg" 
            height={props.height}
            viewBox="0 -960 960 960" 
            width={props.width}
            fill={props.fill}
        >
            <path d="M735.38-160H224.62q-26.66 0-45.64-18.98T160-224.62v-510.76q0-26.66 18.98-45.64T224.62-800h510.76q26.66 0 45.64 18.98T800-735.38v510.76q0 26.66-18.98 45.64T735.38-160Zm-6.15-133.85H230.77v72.31h498.46v-72.31Zm-498.46-35.38h498.46v-72.31H230.77v72.31Zm0-116.92h498.46v-283.08H230.77v283.08Zm0 152.3v72.31-72.31Zm0-35.38v-72.31 72.31Zm0-116.92v-283.08 283.08Zm0 44.61v-44.61 44.61Zm0 107.69v-35.38 35.38Z"/>
        </svg>
    );
};

export default IconPrivacyTip;
